import classNames from 'classnames'
import React from 'react'
import { useFlexLayout } from 'react-table'
import { makeStyles } from 'tss-react/mui'
import { ExtendableStyles } from 'utils-next/types'

import { Table as TableInternal, TableBody } from '@mui/material'

import { TableColumn, useTable } from './Table.hooks'
import { TableHeader } from './TableHeader.component'
import { generateRowList } from './TableRowList.component'

export type TableProps<DataType extends object> = ExtendableStyles & {
  columns: TableColumn<DataType>[]
  data: DataType[]
  onRowSelect?: (data: DataType) => void
  shouldHighlight?: (data: DataType) => boolean
}

export function Table<DataType extends object>({
  className,
  style,
  columns,
  data,
  onRowSelect,
  shouldHighlight,
}: TableProps<DataType>) {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable<DataType>(
    {
      columns,
      data,
    },
    useFlexLayout
  )
  const { classes } = useStyles()

  return (
    <TableInternal className={classNames(className, classes.tableContainer)} style={style} {...getTableProps()}>
      <TableHeader headerGroups={headerGroups} />
      <TableBody {...getTableBodyProps()}>
        {generateRowList(rows, prepareRow, { onRowSelect, shouldHighlight })}
      </TableBody>
    </TableInternal>
  )
}

const useStyles = makeStyles()({
  tableContainer: {
    display: 'table',
    borderCollapse: 'collapse',
    flexDirection: undefined,
  },
})
